import React from "react";
import {ProcessedTripItinerary, TourOperator} from "../contentfulModel.ts";

interface ItineraryIntroPDFProps {
    tourPackage: ProcessedTripItinerary;
    tourOperator: TourOperator
}

export const ItineraryIntroPDF : React.FC<ItineraryIntroPDFProps> = ({tourPackage,tourOperator}) => {


    return (
      <div id="intro" style={{
          backgroundImage: `url(${tourPackage?.introductionImage.file?.includes(" ") ? encodeURI(tourPackage?.introductionImage.file) : tourPackage?.introductionImage.file})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          aspectRatio:  1.4136,
          height:"29.71cm",
          width: "42cm"
      }}
           className="flex items-center justify-center  p-20 relative">
          <div className="absolute inset-0 z-0" style={{
              background: "linear-gradient(270deg, rgba(17, 17, 17, 0.8) 0%, rgba(17, 17, 17, 0.7) 20%, rgba(17, 17, 17, 0.6) 30%, rgba(17, 17, 17, 0.5) 50%, rgba(17, 17, 17, 0.1) 75%, rgba(17, 17, 17, 0.05) 80%, rgba(17, 17, 17, 0) 90%)"
          }}></div>
          <div className="w-[55%] h-full relative">
              <div className="max-w-[150px]"><img src={encodeURI(tourPackage.useLogoContrastIntro ? tourOperator?.logoContrast.file : tourOperator?.logo.file)}/></div>
          </div>
          <div className="w-[45%] h-full flex flex-col justify-between relative">
              <div>
                  <div className="text-start text-white font-light uppercase" style={{
                      fontSize: "70pt",
                      lineHeight: "70pt",
                  }}>{tourPackage?.name}</div>
                  <p className="text-start text-2xl mt-5 font-light text-white" style={{
                      fontSize: "18pt",
                      lineHeight: "18pt",
                  }}>{tourPackage.description}</p>
              </div>
              <div className="flex items-center justify-end gap-4">
                  <div className="rounded-full px-6 py-4  font-medium text-2xl uppercase" style={{
                        color: tourOperator.primaryColor || "#000000",
                      fontSize: "22pt",
                      lineHeight: "22pt",
                      background: "rgba(255, 255, 255, 0.9)"

                  }}>{tourPackage.subtitle || tourPackage.itinerary.length - 1 + " NOCHES"} </div>
                  {tourPackage.price && (
                  <div className="rounded-full px-6 py-2  font-medium text-2xl" style={{
                      color: tourOperator.primaryColor || "#000000",
                      fontSize: "20pt",
                      lineHeight: "18pt",
                      background: "rgba(255, 255, 255, 0.9)"
                  }}><div className="text-[10pt] uppercase font-light">Desde</div>
                      <div>{tourPackage.price}</div></div> )}
              </div>
          </div>
      </div>
  );
};
